<div [innerHTML]="selectedTemplate?.header || '' | safeHtml"></div>
<div [innerHTML]="selectedTemplate?.body || '' | safeHtml"></div>
<div [innerHTML]="selectedTemplate?.footer || '' | safeHtml"></div>